import * as predictors from "../libs/predictors";
import * as moneyplaners from "../libs/moneyplaners";
import { post, get } from '../libs/fetch'

export const ADD_RESULT = "baccarat/ADD_RESULT";
export const RESET_RESULTS = "baccarat/RESET_RESULTS";
export const UNDO_LAST_RESULTS = "baccarat/UNDO_LAST_RESULTS";
export const PREDICT = "baccarat/PREDICT";
export const SET_PREDICTOR = "settings/SET_PREDICTOR"
export const SET_MONEYPLAN = "settings/SET_MONEYPLAN"
export const SET_FIRSTTIME = "settings/SET_FIRSTTIME"
export const SET_GAMEMODE = "settings/SET_GAMEMODE"
export const SET_GAMEROOM = "settings/SET_GAMEROOM"
export const SET_SA_DATA = "settings/SET_SA_DATA"


export const LOADING = "app/LOADING"
export const TOAST = "app/TOAST"

export const LOGIN = "auth/LOGIN"
export const LOGOUT = "auth/LOGOUT"


export const loading = (isLoading) => ({ type: LOADING, data: isLoading })
export const toast = (message) => ({ type: TOAST, data: message })


export const spzLogin = (authToken, username, password) => {
    return async (dispatch) => {
        dispatch(loading(true))
        try{
            const resp = await post('auth/spz', { token: authToken, username, password });
            dispatch({
                type: LOGIN,
                data: resp.data,
            })
        }catch(err) {
            dispatch(toast(err.message))
        }
        dispatch(loading(false))
    }
}

export const fbLogin = (fbData) => {
    return async (dispatch) => {
        dispatch(loading(true))
        try{
            const resp = await post(fbData.renew ? 'auth/renew' : 'fblogin', fbData);
            dispatch({
                type: LOGIN,
                data: resp.data,
            })
        }catch(err) {
            dispatch(toast(err.message))
        }
        dispatch(loading(false))
    }
}

export const redeem = (code, name) => {
    return async (dispatch) => {
        try{
            dispatch(loading(true))
            const data = await post('code/redeem', { code });
            dispatch(fbLogin({ renew: true, name }))
        }catch(err) {
            dispatch(toast(err.message))
        }
        dispatch(loading(false))
    }
}


export const getVendorTables = (vendor, currentRoom, oldResults) => {
    return async (dispatch) => {
        try{
            const data = await get(`${vendor}-table`);
            dispatch(setSATables(data.data))

            if (currentRoom && oldResults) {
                
                const room = data.data.filter(r => r.name === currentRoom).pop()
                if (room) {
                    const newResults = room.data.toUpperCase().split(',');
                    if (newResults.length < oldResults.length) {
                        dispatch(resetResult())
                        dispatch(addResult(newResults))
                    } else 
                    if (newResults.length > oldResults.length) {
                        const addedResults = newResults.slice(oldResults.length)
                        dispatch(addResult(addedResults))
                    } else {
                        console.log('No updated')
                    }
                    // console.log(oldResults, )
                }else {
                    console.log('No room selected', currentRoom)
                }
                
            }

        }catch(err) {
            console.log(err)
            dispatch(toast(err.message))
        }
    }
}

export const getSATables = (currentRoom, oldResults) => getVendorTables('sa', currentRoom, oldResults)
export const getSexyTables = (currentRoom, oldResults) => getVendorTables('sexy', currentRoom, oldResults)

export const setGameRoom = (room) => {
    return async (dispatch) => {
        dispatch(_setGameRoom(room ? room.name : ''))
        if (room) {
            dispatch(resetResult())
            dispatch(addResult(room.data.toUpperCase().split(',')))
        }
    }
}


export const logout = () => ({ type: LOGOUT })

const setSATables = (r) => ({
    type: SET_SA_DATA,
    data: r,
});

export const setGameMode = (r) => ({
    type: SET_GAMEMODE,
    data: r,
});

const _setGameRoom = (r) => ({
    type: SET_GAMEROOM,
    data: r,
});


const mustbeArray = r => {
    if (Array.isArray(r)) {
        return r;
    }

    return [r];
}
export const addResult = (r) => ({
    type: ADD_RESULT,
    data: mustbeArray(r).filter(x => !!x),
});

export const resetResult = () => ({
    type: RESET_RESULTS,
});

export const undoLast = () => ({
    type: UNDO_LAST_RESULTS,
});

export const predict = (predictor, moneyPlanner, state) => {
    return async (dispatch) => {
        
        const [r, v] = await Promise.all([
            predictors[predictor](state.results), 
            moneyplaners[moneyPlanner](state.results, state.winloss)]
        );
        dispatch({
            type: PREDICT,
            data: {
                predict: r,
                money: v,
                nextGame: state.nextGame,
            }
        })
    }
}


export const setPredictor = (p) => ({
    type: SET_PREDICTOR,
    data: p,
});
export const setMoneyplan = (p) => ({
    type: SET_MONEYPLAN,
    data: p,
});
export const setFirsttime = (p) => ({
    type: SET_FIRSTTIME,
    data: p,
});
